import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class StaticTaxTypeLookup extends ModelBase {

    public taxId: number = 0;

    public taxDescription: string = "";
}